
export const common = {
  professionalTerminologyDatabase: 'Fachterminologie-Datenbank',
  cheese: 'Cheese',
  feeding: 'Feeding',
  rush: 'Rush',
  balance: 'Balance',
  fightingGamesJapanese: 'Fighting-Spiele – Japanisch',
  mobaGamesKorean: 'MOBA-Spiele – Koreanisch',
  starcraftRussian: 'StarCraft – Russisch',
  actionGamesChinese: 'Action-Spiele – Chinesisch',
  // Navigation
  home: "Startseite",
  features: "Kernvorteile",
  cases: "Fallstudien", 
  pricing: "Preise",
  about: "Über uns",
  getStarted: "Loslegen",
  language: "Deutsch",

  // Common Actions
  contactUs: "Kontakt",
  viewFaq: "Hier entlang",

  // Hero Section
  heroSubtitle: "Flidge – Die beste Lokalisierung für Spiele",
  heroTitle1: "Ermögliche Spielern weltweit,",
  heroTitle2: "dein Spiel wirklich zu verstehen",
  heroDescription: "Mit fortschrittlicher KI-Technologie bieten wir Entwicklern präzise, schnelle und kosteneffektive mehrsprachige Übersetzungslösungen. Erobere weltweite Spielermärkte und neue Chancen.",
  learnMore: "Vorteile entdecken",
  freeTrial: "Gratis testen",
  socialProof: "Die Wahl von über 80 Spieleentwicklern und Publishern",
  
  // Features Section
  featuresSubtitle: "Kernvorteile",
  featuresTitle: "Effiziente Lokalisierungslösungen für Spiele",
  
  feature1Title: "Schnell und effizient",
  feature1Description: "Präzise, hochwertige Übersetzungen in kürzerer Zeit: Bis zu 200.000 Zeichen können innerhalb von 1 Tag übersetzt werden. Dies steigert die Lokalisierungseffizienz von Spielprojekten erheblich. Im Vergleich zu herkömmlichen manuellen Übersetzungen werden menschliche Fehler deutlich reduziert. Groß- und Kleinschreibung sowie Interpunktion werden präzise erkannt. Die Übersetzungsqualität ist von Übersetzungsagenturen zertifiziert.",
  
  feature2Title: "Mehrsprachig für jedes Szenario", 
  feature2Description: "Wir bieten Übersetzungen in 64 Sprachen weltweit und unterstützen vielfältige Inhalte – von Spielskripten über Store-Seiten, Spieltitel und Glossare bis hin zu offiziellen Websites. So decken wir alle Ihre Lokalisierungsbedürfnisse ab.",

  // Feature 2 Additional
  glossary: "Glossar",
  gameTermsReference: "Spielterminologie-Referenz",
  storePage: "Store-Seite",
  storePageDesc: "Spieltitel, Spielbeschreibung, Verkaufsargumente und Werbeslogans",
  gameStoryTranslation: "Story-Übersetzung",
  gameStoryDesc: "Hauptquests, Nebenquests",
  completed: "Abgeschlossen",
  inProgress: "In Bearbeitung",
  pending: "Wartend",

  feature3Title: "Unterstützt verschiedene Textformate",
  feature3Description: "Unterstützt den Import und Export verschiedener Textformate, sodass Sie übersetzte Texte nahtlos in Ihr Spielprojekt laden können – mit jeder beliebigen Game-Engine.",
  
  feature4Title: "Lokalisierung mit echtem Gaming-Know-how",
  feature4Description: "Spezialisiert auf Game-Lokalisierung mit fundiertem Verständnis für Spieltexte, Dialoge und UI-Elemente in verschiedenen Kontexten. Umfangreiche Spiel-Terminologiedatenbank sorgt für natürliche, zielgruppengerechte Übersetzungen, die Spieler direkt ansprechen.",
  
  // Feature 4 Additional
  professionalGlossary: "Professionelles Glossar",
  more: "Mehr",
  
  // Features Section Additional
  translationTimeComparison: "Übersetzungszeit im Vergleich",
  basedOnProject: "Bei 200.000 Zeichen pro Projekt",
  traditionalAgency: "Herkömmliche Methode",
  aiPlatform: "Flidge AI Übersetzungsdienst",
  days: " Tage",
  day: " Tag",
  hours: " Stunden",
  hour: " Stunde",
  "10days": "10 Tage",
  "1day": "1 Tag",
  "240hours": "240 Stunden", 
  "24hours": "24 Stunden",

  // Case Studies Section
  casesSubtitle: "Fallstudien",
  casesTitle: "Indie-Spiele einem weltweiten Publikum zugänglich machen",
  casesDescription: "Wir schätzen jede Zusammenarbeit – und es ist unsere Mission, Indie-Games dabei zu unterstützen, ein weltweites Publikum zu erreichen",
  
  // Game Types
  platformActionGame: "Action-Plattformer",
  musicRhythmGame: "Rhythmusspiel",
  actionStealthGame: "Action-Stealth-Spiel",
  casualPuzzleGame: "Études de casual-Puzzle-Spiel",
  roguelikeCardGame: "Simulations-Managementspiel",
  simulationGame: "Aufbausimulation",
  
  // Game Descriptions
  haakDescription: "14-sprachige Lokalisierung für das Metroidvania-Spiel HAAK – monatliche Umsatzsteigerung von 147 %",
  museDashDescription: "Lokalisierung von Muse Dash ins Japanische, Koreanische und Englische – hochwertige Inhalte für über 100 Millionen Spieler weltweit",
  kristalaDescription: "Chinesische Übersetzung für das Action-Stealth-Spiel Kristala, einschließlich Spielname und Store-Seite",
  lazyMeowDescription: "Lokalisierungsunterstützung für das Études de casual-Puzzle-Spiel Lazy Meow City in Englisch, Japanisch und Koreanisch, die dem Spiel beim Durchbruch im asiatisch-pazifischen Markt half",
  stoneSquadDescription: "Lokalisierung von Cooking Go in 12 Sprachen, darunter Englisch, Japanisch, Koreanisch, Französisch und Spanisch",
  catHotelDescription: "Übersetzungsdienstleistungen für CatHotel in Englisch, Japanisch, vereinfachtem und traditionellem Chinesisch: Story, Quests, Items und Store-Seiten für ein authentisches, lokalisiertes Spielerlebnis",
  
  // Results
  monthlyRevenueGrowth: "147% monatliches Umsatzwachstum",
  playerReviews: "Positive Spielerbewertungen",
  translationCompleted: "Übersetzung abgeschlossen",
  salesIncrease: "Verkaufssteigerung",
  exposureGrowth: "Belichtungswachstum",
  playerReviews2: "Positive Spielerbewertungen",
  result: "Ergebnis",
  customerReviews: 'Kundenbewertung',
  realUserFeedback: 'Echte Nutzerstimmen',
  
  // Pricing Section
  pricingSubtitle: "Preise",
  pricingTitle: "Transparente Preisgestaltung",
  pricingDescription: "Wir bieten flexible Preismodelle für Projekte jeder Größe. Jedes Unternehmen erhält kostenloses Testguthaben.",
  
  freeTrialTitle: "Kostenloses Testguthaben",
  standardPricing: "Standardpreis",
  standardPricingDescription: "Standardpreis nach dem Gratiskontingent",
  standardPricingFeatures: {
    languages: "Übersetzung in 64 Sprachen",
    speed: "200.000 Zeichen Übersetzung innerhalb von 24 Stunden",
    formats: "Mehrere Dateiformate",
    glossary: "Gaming-Terminologie",
    quality: "Qualitätssicherung und Überarbeitung"
  },
  customPrice: "Angepasst",
  customPlan: "Preisplan",
  customPlanDescription: "Sonderkonditionen für Großprojekte",
  
  // Enterprise Features
  enterpriseCustom: "Unternehmenslösung",
  recommended: "Empfohlen",
  perCharacter: "pro Zeichen",
  perLanguage: "pro Sprache",
  startUsing: "Jetzt starten",
  contactBusinessTeam: "Vertriebsteam kontaktieren",
  
  enterpriseFeatures: {
    allStandard: "Inklusive aller Funktionen der Standardversion",
    manager: "Persönlicher Account Manager",
    priority: "Priorisierte Bearbeitung & Express-Service",
    customGlossary: "Individuelle Terminologiedatenbanken & Stilrichtlinien",
    discount: "Mengenrabatte & Langfristige Partnerschaftsvorteile",
    extraTrial: "Zusätzliches Testguthaben beantragen"
  },

  // Pricing Section Additional
  languagesCount: "Sprachen",
  freeExperience: "Kostenlose Testphase", 
  freeTrialDescription: "Jeder Partner erhält ein kostenloses Testkontingent von 5.000 Zeichen für eine Zielsprache, um unsere Übersetzungsqualität ausgiebig kennenzulernen",
  
  // New Pricing Calculator Section
  priceCalculator: "Preisrechner",
  calculatorDescription: "Berechnen Sie schnell Ihre Projektkosten",
  charactersCount: "Zeichenanzahl",
  targetLanguagesCount: "Anzahl der Zielsprachen",
  estimatedCost: "Geschätzte Kosten",
  
  calculationNotes: "Zur Berechnung",
  calculationDetails: {
    freeQuota: "Jedes Kooperationspartner erhält 5.000 Zeichen kostenlos (nur für eine Sprache)",
    pricing: "Darüber hinaus: $0,011/Zeichen/Sprache",
    bulkDiscount: "Für umfangreiche Projekte bieten wir maßgeschneiderte Unternehmenspreise",
    finalPrice: "Der endgültige Preis wird von unserem Vertriebsteam ermittelt"
  },

  // About Section
  aboutSubtitle: "Über uns",
  aboutTitle: "Professionelles Team für Spielelokalisierung",
  aboutDescription: "Flidge wurde 2019 gegründet und ist ein Technologieunternehmen, das sich auf Spielelokalisierung spezialisiert hat. Wir kombinieren KI-Technologie mit professionellem menschlichem Lektorat, um Spieleentwicklern weltweit hochwertige und effiziente mehrsprachige Lokalisierungsdienste zu bieten und herausragende Spiele weltweit erfolgreich zu machen.",
  
  ourMission: "Unsere Mission",
  ourVision: "Unsere Vision",
  missionText: "Durch fortschrittliche KI-Technologie und professionelle Lokalisierungsdienste überwinden wir Sprachbarrieren und ermöglichen es jedem herausragenden Spiel, auf dem globalen Markt erfolgreich zu sein – damit Spieler auf der ganzen Welt ein begeisterndes Spielerlebnis genießen können.",
  visionText: "Als weltweit führende Plattform für Spielelokalisierung treiben wir durch technologische Innovation und professionelle Dienstleistungen die globale Entwicklung der Spielebranche voran und bringen herausragende Spielekultur in alle Welt.",
  
  // FAQ Section
  faqSubtitle: 'Häufig gestellte Fragen',
  faqTitle: 'Häufig gestellte Fragen',
  faqDescription: 'Bei weiteren Fragen können Sie sich jederzeit gerne an uns wenden',
  stillHaveQuestions: "Haben Sie noch Fragen?",
  
  faqQuestion1: 'Bieten Sie ein kostenloses Testkontingent an?',
  faqQuestion2: 'Ab welcher Entwicklungsphase empfiehlt sich die Nutzung von Flidge?',
  faqQuestion3: 'Was mache ich, wenn mein Spielprojekt kein Glossar hat?',
  faqQuestion4: 'Wird der Inhalt meines Spiels streng vertraulich behandelt?',
  
  // FAQ Items
  faq1Question: "Bieten Sie ein kostenloses Testkontingent an?",
  faq1Answer: "Wir bieten jedem Partner ein kostenloses Testkontingent von 5.000 Zeichen für eine Zielsprache. Darüber hinaus berechnen wir 0,016 USD pro Zeichen und Zielsprache. Sollten Sie zusätzliches Testkontingent benötigen, können Sie unser Vertriebsteam kontaktieren.",
  
  faq2Question: "Ab welcher Entwicklungsphase empfiehlt sich die Nutzung von Flidge?",
  faq2Answer: "Wir empfehlen, Flidges Dienste in mittleren bis späten Entwicklungsphasen Ihres Spielprojekts zu nutzen – so können Sie Lokalisierungskosten bestmöglich reduzieren. Gleichzeitig unterstützen wir Sie bei der Übersetzung Ihrer Store-Seite und helfen Ihnen, geeignetere lokalisierte Spieltitel auszuwählen, damit Spieler sich Ihr Spiel leichter merken können und Sie globale Märkte besser erschließen.|Wenn Ihr Spiel kurz vor dem Launch auf Steam oder anderen Gaming-Plattformen steht, ist Flidge ideal für Sie – wir erledigen umfangreiche Lokalisierungsarbeiten in verschiedenen Sprachen in kürzester Zeit, sodass Spieler weltweit Ihr Spiel entdecken können.",
  
  faq3Question: "Was mache ich, wenn mein Spielprojekt kein Glossar hat?",
  faq3Answer: "Wir können Sie über Flidge AI bei der Glossar-Erstellung unterstützen und helfen Ihnen, Ihr Projekt und die zu übersetzenden Inhalte besser zu verwalten. Wir prüfen und bestätigen gemeinsam mit Ihnen die Verwendung der Terminologie, um sicherzustellen, dass diese in Ihrem Spiel korrekt eingesetzt wird.\nWenn Sie unseren Service zur Glossar-Erstellung benötigen, kontaktieren Sie uns gerne jederzeit.",
  
  faq4Question: "Wird der Inhalt meines Spiels streng vertraulich behandelt?",
  faq4Answer: "Wir setzen branchenübliche Verschlüsselung und speziell für Gaming-Projekte entwickelte, isolierte Workflows ein. Jedes Teammitglied arbeitet unter strikten Geheimhaltungsvereinbarungen mit klarer finanzieller Haftung. Unsere Entwicklungsumgebung gewährleistet vollständige Asset-Isolation – keine Screenshots, keine externen Laufwerke, keine privaten Geräte. Wir verstehen, dass geleakte Spielszenen, Story-Elemente oder Release-Termine die Marktchancen eines Spiels gefährden können – Ihr geistiges Eigentum erhält denselben Schutz, den wir für unsere eigenen unveröffentlichten Projekte einfordern.",
  
  // CTA Section
  ctaTitle1: "Lass die Welt",
  ctaTitle2: "dein Spiel lieben",
  
  // Contact Section
  contactSubtitle: "Kontakt",
  contactTitle: "Professionelle Übersetzungen und kostenloses Testguthaben",
  contactDescription: "Füllen Sie das untenstehende Formular aus – unser Fachteam sendet Ihnen innerhalb von 24 Stunden ein detailliertes Angebot zu",
  
  name: "Name",
  email: "E-Mail",
  company: "Firmen-/Studioname",
  targetLanguages: "Zielsprachen",
  projectDetails: "Projektdetails",
  getQuote: "Angebot anfordern",
  onlineConsult: "Online-Beratung",
  emailContact: "E-Mail senden",
  
  // Footer
  footerDescription: "Wir bieten Indie-Games effiziente, unkomplizierte und kosteneffektive Lokalisierungsdienste. Mit intelligenter Übersetzung, Analyse und personalisierten Sprachdienstleistungen unterstützen wir Spieleprojekte bei ihrem globalen Wachstum.",
  services: "Dienste",
  companySection: "Unternehmen",
  resources: "Ressourcen",
  featuresLink: "Kernvorteile",
  pricingConsult: "Preisrechner",
  aboutUs: "Über uns",
  helpCenter: "Hilfezentrum",
  techBlog: "Tech-Blog",
  termsOfService: "Nutzungsbedingungen",
  privacyPolicy: "Datenschutzerklärung",
  cookiePolicy: "Cookie-Richtlinie",
  poweredBy: "Powered by Readdy",
  copyright: "© 2026 Shenzhen Giant Core Limited. All rights reserved.",
  
  // Form labels
  required: "*",
  characterCount: "Zeichen",
  
  // Form placeholders
  namePlaceholder: "Bitte geben Sie Ihren Namen ein",
  emailPlaceholder: "Bitte geben Sie Ihre E-Mail-Adresse ein",
  companyPlaceholder: "Bitte geben Sie Firmen- oder Studio-Namen ein",
  languagesPlaceholder: "z.B.: Englisch, Japanisch, Koreanisch, etc.",
  messagePlaceholder: "Bitte beschreiben Sie Ihre Projektanforderungen detailliert, einschließlich Spieltyp, Übersetzungsinhalt, besondere Anforderungen, etc...",
  
  // Alt texts
  gameIcon: "Spiel-Icon",
  flidgeLogo: "Flidge-Logo",
  abstractShape: "Abstrakte Form",
  
  // Testimonials
  testimonialSarahRole: "Unabhängige Spieleentwicklerin",
  testimonialSarahContent: "Seit wir Flidge nutzen, ist die Resonanz auf unser Spiel in internationalen Märkten hervorragend. Die Übersetzungsqualität übertrifft alle Erwartungen – Spieler berichten, dass die Story hervorragend vermittelt wird und völlig natürlich wirkt.",
  
  testimonialThijsRole: "Spielstudio-Direktor",
  testimonialThijsContent: "Von der ersten Skriptübersetzung bis hin zur Textoptimierung hat das Flidge-Team durchweg höchste Professionalität bewiesen. Ihr Verständnis für Spielekultur hat die Lokalisierung erheblich erleichtert.",
  
  testimonialEmmaRole: "Spiel-Lokalisierungs-Managerin",
  testimonialEmmaContent: "Der Übersetzungsservice von Flidge hat uns enorm viel Zeit und Kosten gespart. Seine KI-Technologie arbeitet nicht nur schnell, sondern erfasst auch präzise die Fachterminologie und kulturellen Nuancen in unserem Spiel.",
  
  testimonialDavidRole: "Spielproduzent",
  testimonialDavidContent: "Den großen Erfolg unseres Spiels auf dem japanischen und koreanischen Markt verdanken wir dem erstklassigen Lokalisierungsservice von Flidge. Sein tiefgreifendes Verständnis ostasiatischer Kulturen macht die Übersetzungen besonders authentisch.",
  
  testimonialAlexRole: "Unabhängiger Entwickler",
  testimonialAlexContent: "Als kleines Team waren die Lokalisierungskosten unsere größte Sorge. Flidge bietet nicht nur faire Preise, sondern arbeitet auch extrem effizient, sodass wir gleichzeitig in mehrere internationale Märkte expandieren konnten.",
  
  testimonialYukiRole: "Spielplaner",
  testimonialYukiContent: "Flidges Verständnis für japanische Gaming-Kultur hat mich tief beeindruckt. Sie haben nicht nur Worte übersetzt, sondern den Geist des Spiels vermittelt, sodass auch internationale Spieler das authentische Erlebnis genießen können.",
  
  abstractShape2: "Abstrakte Form 2",

  // New entries from modification
  partners: "Partner",
  trustedPartners: "Vertrauenswürdige Partner",
  partnersDescription: "Langfristige, tiefgreifende Partnerschaften mit weltweit führenden Gaming-Teams und Unternehmen",

  gameProjectsServed: "Bediente Unternehmen",
  supportedLanguages: "Unterstützte Sprachen",
  clientSatisfaction: "Kundenzufriedenheit",
  responseTime: "Antwortzeit",

  // Additional Metrics
  translatedCharactersCount: "5M+",
  avgTranslationSpeedValue: "3,2 Sekunden",
  translatedCharacters: "Wörter übersetzt",
  avgTranslationSpeed: "Ø Übersetzungszeit pro 1.000 Wörter",
  clientSatisfactionRate: "Kundenzufriedenheit",
  servicedCompanies: "Betreute Kunden",
  successMetrics: "Erfolgskennzahlen",
  serviceImpact: "Service-Impact",

  // Statistics
  stat1Number: '80+',
  stat1Label: 'Bediente Unternehmen',
  stat2Number: '64',
  stat2Label: 'Unterstützte Sprachen',
  stat3Number: '97%',
  stat3Label: 'Kundenzufriedenheit',
  stat4Number: '24h',
  stat4Label: 'Antwortzeit',

  // Terms of Service
  termsTitle: 'Nutzungsbedingungen',
  termsLastUpdated: 'Zuletzt aktualisiert: Januar 2025',
  terms1Title: '1. Annahme der Bedingungen',
  terms1Content: 'Durch den Zugriff auf und die Nutzung von Flidge AI Translation Services akzeptieren Sie diese Vereinbarung und stimmen zu, an deren Bedingungen gebunden zu sein.',
  terms2Title: '2. Nutzungslizenz',
  terms2Content: 'Es wird die Erlaubnis erteilt, eine Kopie der Materialien auf Flidges Website temporär für persönliche, nicht-kommerzielle Betrachtung herunterzuladen.',
  terms3Title: '3. Haftungsausschluss',
  terms3Content: 'Die Materialien auf Flidges Website werden "wie besehen" bereitgestellt. Flidge gibt keine ausdrücklichen oder stillschweigenden Garantien ab.',
  terms4Title: '4. Beschränkungen',
  terms4Content: 'Flidge oder seine Lieferanten haften in keinem Fall für Schäden, die durch die Nutzung oder Unfähigkeit zur Nutzung der Materialien entstehen.',
  terms5Title: '5. Genauigkeit der Materialien',
  terms5Content: 'Die auf Flidges Website erscheinenden Materialien können technische, typografische oder fotografische Fehler enthalten.',
  terms6Title: '6. Links',
  terms6Content: 'Flidge hat nicht alle mit unserer Website verlinkten Seiten überprüft und ist nicht für deren Inhalte verantwortlich.',
  terms7Title: '7. Änderungen',
  terms7Content: 'Flidge kann diese Nutzungsbedingungen jederzeit ohne Vorankündigung überarbeiten.',
  terms8Title: '8. Geltendes Recht',
  terms8Content: 'Diese Geschäftsbedingungen unterliegen dem geltenden Recht und werden entsprechend ausgelegt.',

  // Privacy Policy
  privacyTitle: 'Datenschutzerklärung',
  privacyLastUpdated: 'Zuletzt aktualisiert: Januar 2025',
  privacy1Title: '1. Informationen, die wir sammeln',
  privacy1Content: 'Wir sammeln Informationen, die Sie uns direkt zur Verfügung stellen, wie beim Erstellen eines Kontos oder der Nutzung unserer Übersetzungsdienste.',
  privacy2Title: '2. Wie wir Ihre Informationen verwenden',
  privacy2Content: 'Wir verwenden die gesammelten Informationen, um unsere Übersetzungsdienste bereitzustellen, zu warten und zu verbessern.',
  privacy3Title: '3. Informationsaustausch',
  privacy3Content: 'Wir verkaufen, handeln oder übertragen Ihre persönlichen Informationen nicht ohne Ihre Zustimmung an Dritte.',
  privacy4Title: '4. Datensicherheit',
  privacy4Content: 'Wir implementieren angemessene Sicherheitsmaßnahmen zum Schutz Ihrer persönlichen Informationen.',
  privacy5Title: '5. Datenspeicherung',
  privacy5Content: 'Wir bewahren Ihre persönlichen Informationen so lange auf, wie es für die Bereitstellung unserer Dienste erforderlich ist.',
  privacy6Title: '6. Ihre Rechte',
  privacy6Content: 'Sie haben das Recht, auf Ihre persönlichen Informationen zuzugreifen, diese zu aktualisieren und deren Löschung zu beantragen.',
  privacy7Title: '7. Cookies und Tracking',
  privacy7Content: 'Wir verwenden Cookies und ähnliche Tracking-Technologien, um Ihre Erfahrung auf unserer Website zu verbessern.',
  privacy8Title: '8. Internationale Übertragungen',
  privacy8Content: 'Ihre Informationen können in andere Länder übertragen und dort verarbeitet werden.',
  privacy9Title: '9. Änderungen an dieser Richtlinie',
  privacy9Content: 'Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren.',
  privacy10Title: '10. Kontaktieren Sie uns',
  privacy10Content: 'Bei Fragen zu dieser Datenschutzerklärung kontaktieren Sie uns unter privacy@flidge.ai.',

  // Cookie Policy
  cookieTitle: 'Cookie-Richtlinie',
  cookieLastUpdated: 'Zuletzt aktualisiert: Januar 2025',
  cookie1Title: '1. Was sind Cookies',
  cookie1Content: 'Cookies sind kleine Textdateien, die auf Ihrem Gerät platziert werden, wenn Sie unsere Website besuchen.',
  cookie2Title: '2. Arten von Cookies, die wir verwenden',
  cookie2Content: 'Wir verwenden wesentliche Cookies für grundlegende Website-Funktionen, Leistungs-Cookies zur Analyse von Nutzungsmustern und funktionale Cookies.',
  cookie2Essential: 'Wesentliche Cookies',
  cookie2EssentialDesc: 'Diese Cookies sind für das ordnungsgemäße Funktionieren der Website erforderlich.',
  cookie2Performance: 'Leistungs-Cookies',
  cookie2PerformanceDesc: 'Diese Cookies sammeln Informationen darüber, wie Besucher unsere Website nutzen.',
  cookie2Functional: 'Funktionale Cookies',
  cookie2FunctionalDesc: 'Diese Cookies ermöglichen es der Website, sich an Ihre Entscheidungen zu erinnern.',
  cookie3Title: '3. Drittanbieter-Cookies',
  cookie3Content: 'Wir können Drittanbieterdienste verwenden, die Cookies auf Ihrem Gerät platzieren.',
  cookie4Title: '4. Cookies verwalten',
  cookie4Content: 'Sie können Cookies über Ihre Browser-Einstellungen kontrollieren und verwalten.',
  cookie5Title: '5. Cookie-Zustimmung',
  cookie5Content: 'Durch die weitere Nutzung unserer Website stimmen Sie unserer Verwendung von Cookies zu.',
  cookie6Title: '6. Auswirkungen der Deaktivierung von Cookies',
  cookie6Content: 'Wenn Sie Cookies deaktivieren, funktionieren einige Funktionen unserer Website möglicherweise nicht ordnungsgemäß.',
  cookie7Title: '7. Aktualisierungen dieser Richtlinie',
  cookie7Content: 'Wir können diese Cookie-Richtlinie von Zeit zu Zeit aktualisieren.',
  cookie8Title: '8. Kontaktinformationen',
  cookie8Content: 'Bei Fragen zur Verwendung von Cookies kontaktieren Sie uns unter cookies@flidge.ai.'
};
export default common;
